"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DirectAttachment = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.DirectAttachment = typebox_1.Type.Object({
    content: typebox_1.Type.String(),
    type: typebox_1.Type.String(),
    filename: typebox_1.Type.String(),
    disposition: typebox_1.Type.String(),
});
//# sourceMappingURL=direct-attachment.js.map